import { render } from "./ev1TabThree.vue?vue&type=template&id=7420a135&scoped=true"
import script from "./ev1TabThree.vue?vue&type=script&lang=js"
export * from "./ev1TabThree.vue?vue&type=script&lang=js"

import "./ev1TabThree.vue?vue&type=style&index=0&id=7420a135&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7420a135"]])

export default __exports__